
import {
    GET_KATUZE_INFO_ACTION_TYPE,
} from '../../sagas/isknActual';

import { createLoaderReducer } from '../../common/client/reducers/loader';

export function getKatuzeInfoData(state) {
    return state.data?.result?.result?.data;
}

export default function createReducer() {
    return createLoaderReducer(GET_KATUZE_INFO_ACTION_TYPE);
}
